import { BOOT_SPLASH_ELEMENT_ID } from './splash-screen';

/**
 * Fades out and removes the static #mi-boot-splash from index.html once the app
 * is ready. Safe to call multiple times.
 */
export function dismissBootSplash(onRemoved?: () => void) {
  const el = document.getElementById(BOOT_SPLASH_ELEMENT_ID);
  if (!el) {
    onRemoved?.();
    return;
  }
  if (el.classList.contains('mi-splash--dismissed')) {
    return;
  }

  el.classList.add('mi-splash--dismissed');

  const remove = () => {
    el.removeEventListener('transitionend', remove);
    if (el.isConnected) {
      el.remove();
    }
    onRemoved?.();
  };

  el.addEventListener('transitionend', remove, { once: true });
  window.setTimeout(remove, 400);
}

/** Returns true when the static boot splash node is still in the document. */
export function isBootSplashPresent() {
  return document.getElementById(BOOT_SPLASH_ELEMENT_ID) != null;
}
